import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/customers/c9246-190426/frontend/src/app/account/components/AccountClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/customers/c9246-190426/frontend/src/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/customers/c9246-190426/frontend/src/components/Header.tsx");
